const ENV_DEV = 'dev';
const ENV_STAGING = 'staging';
const ENV_PRODUCTION = 'production';

export default class Environment {

  static getEnvironment() {
    let env = ENV_PRODUCTION;
    const hostname = window.location.hostname.split('.')[0];
    const forceStaging = window.location.search.includes('forceProdTesting=true');
    
    if (forceStaging) {
      return ENV_PRODUCTION;
    }
    
    switch (hostname) {
      case 'wac':
      case 'qa-wac':
      case 'author':
      case 'proof':
        env = ENV_STAGING;
        break;
      case 'localhost':
      case 'local':
        env = ENV_DEV;
        break;
      case "truth":
      case "www":
      case "atlassian":
      case "bitbucket":
      case "sourcetreeapp":
      case "agile": 
      case "git":
      case "software":
        return ENV_PRODUCTION;
      default:
        /* for omlet instances */
        env = ENV_STAGING;
    }
    return env;
  }

  static production() {
    return ENV_PRODUCTION;
  }

  static staging() {
    return ENV_STAGING;
  }

  static dev() {
    return ENV_DEV;
  }
}
